import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { useDietsStore } from '@/store/dietsStore'

import type { DietCalculationData, DietCalculationType, DietData } from '@/types/Diet'

export const useEnergyDemand = () => {
  const dietStore = useDietsStore()
  const { diet, caloriesFromNorms } = storeToRefs(dietStore)
  const energyDemandStandard = computed(() => diet.value?.data.calculation.type === 'standard')
  const energyDemandSport = computed(() => diet.value?.data.calculation.type === 'sport')
  const calories = computed(() => diet.value?.data.norms.calories ?? 0)
  const weight = computed(() => diet.value?.data.patient.weight ?? 0)
  const normsActive = computed(() => Boolean(diet.value?.data.norms.active))
  const standardProtein = computed(() => diet.value?.data.calculation.standard.protein ?? 0)
  const standardFat = computed(() => diet.value?.data.calculation.standard.fat ?? 0)
  const standardCarbohydrates = computed(
    () => diet.value?.data.calculation.standard.carbohydrates ?? 0,
  )
  const sportProtein = computed(() => diet.value?.data.calculation.sport.protein ?? 0)
  const sportFat = computed(() => diet.value?.data.calculation.sport.fat ?? 0)
  const sportCarbohydrates = computed(() => diet.value?.data.calculation.sport.carbohydrates ?? 0)
  const proteinGrams = computed(() => diet.value?.data.norms.protein.inputed ?? 0)
  const fatGrams = computed(() => diet.value?.data.norms.fat.inputed ?? 0)
  const carbohydratesGrams = computed(() => diet.value?.data.norms.carbohydrates.inputed ?? 0)
  const handleUpdateCalculation = <
    T extends DietCalculationType,
    X extends keyof DietCalculationData,
  >(
    nutrient: X,
    value: DietData['calculation'][T][X],
    type: T,
  ) => {
    dietStore.updateCalculation({ nutrient, type, value })
  }

  return {
    calories,
    caloriesFromNorms,
    carbohydratesGrams,
    energyDemandSport,
    energyDemandStandard,
    fatGrams,
    handleUpdateCalculation,
    normsActive,
    proteinGrams,
    sportCarbohydrates,
    sportFat,
    sportProtein,
    standardCarbohydrates,
    standardFat,
    standardProtein,
    weight,
  }
}
